class FeaturesArticlesSlider {
	constructor() {
		// view
		this.cname = 'features-articles-slider';
		this.components = document.querySelectorAll(`.${this.cname}`);

		if (this.components) {
			this.init();
		}
	}

	init() {
		this.components.forEach( component => {
			const splideSlider = component.querySelector(".splide");
			if (splideSlider) this.initSplide(splideSlider);
		});
	}
	initSplide( slider ) {
		new Splide( slider, {
			type: 'slide',
			arrows: true,
			pagination: true,
			perMove: 1,
		}).mount();	
	}
}

new FeaturesArticlesSlider();
